import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "projects-list__filters" }
const _hoisted_2 = { class: "projects-list__filters-row projects-list__filters-row--header" }
const _hoisted_3 = {
  key: 0,
  class: "jobs-panel-search__header-inputs"
}
const _hoisted_4 = { class: "jobs-panel-search__header-inputs-item" }
const _hoisted_5 = { class: "jobs-panel-search__header-inputs-item" }
const _hoisted_6 = {
  key: 1,
  class: "projects-list__filters-input"
}
const _hoisted_7 = {
  key: 0,
  class: "projects-list__filters-row projects-list__filters-row--inputs"
}
const _hoisted_8 = { class: "projects-list__filters-select" }
const _hoisted_9 = { class: "projects-list__stages" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "tag-chip__count" }
const _hoisted_12 = {
  key: 0,
  class: "projects-list__selected-clients"
}
const _hoisted_13 = {
  key: 1,
  class: "projects-list__selected-tags"
}
const _hoisted_14 = { class: "projects-list__selected-tags-item-name" }
const _hoisted_15 = { class: "projects-list__filters-counter-value" }
const _hoisted_16 = {
  key: 0,
  class: "projects-list__body-divider"
}
const _hoisted_17 = { class: "projects-list__empty-count" }

import {
	ref,
	computed,
	watch,
	onMounted,
	nextTick
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {searchStore} from "@/store/search";
import { clientPageStore } from "@/store/client-page";
import { headerStore } from "@/store/header";
import { ProjectApi } from "@/ api/ProjectApi";
import ProjectListItem from "@/components/main/search-panel/ProjectListItem.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppSelect from "@/components/ui-kit/select/AppSelect.vue";
import ProjectClientFilterDropdown from "@/components/main/search-panel/dropdowns/ProjectClientFilterDropdown.vue";
import ProjectSelectedClientItem from "@/components/main/search-panel/ProjectSelectedClientItem.vue";
import AppScrollTopButton from "@/components/ui-kit/button/AppScrollTopButton.vue";
import { useScrollTopButton } from "@/composables/useScrollTopButton";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import { TagEntityType } from "@/models/etc/types";
import { i18n } from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectSearchPanel',
  props: {
    isCollapsed: { type: Boolean },
    isSecondCollapsed: { type: Boolean }
  },
  emits: ["on-toggle"],
  setup(__props: any, { emit: __emit }) {

const t = (key: string): string => String(i18n.global.t(key))

const emit = __emit

const props = __props;

const $dropdownRef = ref<typeof AppResizableDropdown | null>(null)
const $clientFilterDropdownRef = ref<typeof AppResizableDropdown | null>(null)
const $projectsList = ref<HTMLDivElement | null>(null)
const store = searchStore()
const clientPage = clientPageStore()
const header = headerStore()
const route = useRoute()
const router = useRouter()
const filter = ref("");
const selectedCategory = ref(-1);
const selectedTags = ref<TagWithFrequency[]>([])
const isCreatingProject = ref(false)
const initialLoadDone = ref(false)
const isCounterHovered = ref(false)

const isEntityPage = computed(() => route.query.page === 'client' || route.query.page === 'project')
const entityType = computed<'client' | 'project'>(() => route.query.page === 'project' ? 'project' : 'client')
const entityId = computed(() => Number(route.query.id) || 0)

const byBaseItem = computed(() => ({ Id: -1, Name: t('search_by_base'), Roles: [] }))

const focusFilterClient = ref<{ Id: number, UseUnion: boolean } | null>(null)

const openClientFilterAt = (client: { Id: number, UseUnion?: boolean }) => {
	focusFilterClient.value = { Id: client.Id, UseUnion: !!client.UseUnion }
	$clientFilterDropdownRef.value?.open()
}

const canCreateProject = computed(() => !!header.currentAccessGroup?.CanCreateProjects)
const createProjectTitle = computed(() =>
	t(canCreateProject.value ? 'project_create' : 'project_create_unavailable')
)
const createProjectHoverColor = computed(() =>
	canCreateProject.value ? '#499259' : '#979797'
)
const createProjectCursor = computed(() =>
	isCreatingProject.value ? 'wait' : (canCreateProject.value ? 'pointer' : 'not-allowed')
)

// Проматывает список проектов до открытого Проекта. Вызывается ТОЛЬКО при
// навигационной (первичной) загрузке — не при ручных поисках на той же странице.
const maybeScrollToOpenedProject = async () => {
	if (entityType.value !== 'project' || !entityId.value) {
		return
	}
	await nextTick()
	const container = $projectsList.value
	if (!container) {
		return
	}
	const el = container.querySelector(`[data-project-id="${entityId.value}"]`)
	if (!el) {
		return
	}
	const cRect = container.getBoundingClientRect()
	const eRect = el.getBoundingClientRect()
	container.scrollTop += eRect.top - cRect.top
}

onMounted(async () => {
	await store.getInitProjects()

	if (isEntityPage.value) {
		await store.loadClientFilterList(entityType.value, entityId.value)
		if (entityType.value === 'client') {
			const opened = clientPage.openedClient
			if (opened?.Id === entityId.value) {
				store.preselectClient({ Id: opened.Id, Name: opened.Name })
			}
		} else {
			store.preselectMainProjectClient()
		}
		await store.getFilteredProjects(filter.value)
		if (entityType.value === 'project') {
			await maybeScrollToOpenedProject()
		}
	}

	initialLoadDone.value = true

	// добор преселекта, если openedClient появился во время монтирования
	await tryPreselectOpenedClient()
})

const onProjectsScroll = () => {
	const el = $projectsList.value
	if (!el || projectsLoading.value) {
		return
	}
	if (el.scrollTop + el.clientHeight >= el.scrollHeight - 800) {
		store.getFilteredProjectsPartion(filter.value)
	}
}

const projects = computed(() => store.allProjects)
const projectsLoading = computed(() => store.projectsLoading || isCreatingProject.value)

const { isScrollTopEnabled, scrollToTop } = useScrollTopButton(
	$projectsList,
	'[data-project-id]',
	() => projects.value
)

const projectsCount = computed(() => store.projectCounter)
const projectsStagesList = computed(() => store.projectsStagesList)
const stageItemsForSelectedStage = computed(() => store.stageItemsForSelectedStage)
const allSelectedStages = computed(() => store.allSelectedStages)
const selectedClients = computed(() => store.selectedClients)
const byBase = computed(() => store.byBase)
// Фильтр по клиентам считается изменённым, пока он не равен «По базе»
const hasClientFilter = computed(() => isEntityPage.value && !byBase.value)

const hasAnyFilter = computed(() =>
	!!filter.value
	|| allSelectedStages.value.length > 0
	|| selectedTags.value.length > 0
	|| selectedCategory.value !== -1
	|| hasClientFilter.value
)

const optionsDisplay = computed(() => {
	if (!projectsStagesList.value.length) {
		return [{
			id: -1,
			label: t('stage_standard'),
			type: 'item'
		}]
	}

	return  projectsStagesList.value.map(stage => ({
		id: stage.Id,
		label: stage.Name,
		type: 'item'
	}))
})

const doSearch = async () => {
	$projectsList.value ? $projectsList.value.scrollTop = 0 : null
	await store.getFilteredProjects(filter.value);
}

function clearSearch() {
	filter.value = "";
}

async function toggleStage(stageId: number) {
	$projectsList.value ? $projectsList.value.scrollTop = 0 : null
	await store.setSelectedStage(stageId, filter.value)
}

const dropFilters = () => {
	filter.value = ""
	selectedCategory.value = -1
	selectedTags.value = []
	store.dropTags()
	if (isEntityPage.value) {
		store.setByBase(true)
	} else {
		store.clearClientFilter()
	}
	doSearch()
}

const dropTag = (tag: TagWithFrequency) => {
	selectedTags.value = selectedTags.value.filter(t => t.Id !== tag.Id)
}

const removeClient = (id: number) => {
	store.removeSelectedClient(id)
	doSearch()
}

// Преселект открытого клиента (страница Клиента). Делает поиск только если действительно выбрал.
const tryPreselectOpenedClient = async () => {
	if (route.query.page !== 'client' || store.byBase) {
		return
	}
	const opened = clientPage.openedClient
	if (!opened?.Id || opened.Id !== entityId.value) {
		return
	}
	if (store.selectedClients.some(c => c.Id === opened.Id)) {
		return
	}
	store.preselectClient({ Id: opened.Id, Name: opened.Name })
	await doSearch()
}

const onCreateProject = async () => {
	if (isCreatingProject.value) {
		return
	}
	if (!canCreateProject.value || header.currentAccessGroupId == null) {
		return
	}

	try {
		isCreatingProject.value = true
		const clientId = store.selectedClients[0]?.Id ?? 0
		const newId = await ProjectApi.createProject(clientId, header.currentAccessGroupId)
		if (newId) {
			store.clearClientFilter()
			await router.push({
				path: '/main',
				query: {
					page: 'project',
					id: String(newId),
				}
			})
		}
	} catch (e) {
		console.error(e)
	} finally {
		isCreatingProject.value = false
	}
}

// Загрузка списка фильтра при открытии Клиента/Проекта/Главной
watch(
	() => [route.query.page, route.query.id],
	async (_curr, [prevPage]) => {
		if (!initialLoadDone.value) return
		if (isEntityPage.value) {
			await store.loadClientFilterList(entityType.value, entityId.value)
			if (entityType.value === 'project') {
				store.preselectMainProjectClient()
				await doSearch()
				await maybeScrollToOpenedProject()
			} else {
				const opened = clientPage.openedClient
				if (opened?.Id === entityId.value) {
					store.preselectClient({ Id: opened.Id, Name: opened.Name })
					await doSearch()
				}
				// иначе преселект и поиск сделает Watcher B по готовности openedClient
			}
		} else if (prevPage === 'client' || prevPage === 'project') {
			store.clearClientFilter()
			await doSearch()
		}
	}
)

// Добивает преселект открытого клиента, если он загрузился позже списка
watch(
	() => clientPage.openedClient?.Id ?? null,
	async () => {
		if (!initialLoadDone.value || route.query.page !== 'client' || store.byBase) {
			return
		}
		const opened = clientPage.openedClient
		if (!opened?.Id || opened.Id !== entityId.value) {
			return
		}
		if (store.selectedClients.some(c => c.Id === opened.Id)) {
			return
		}
		store.preselectClient({ Id: opened.Id, Name: opened.Name })
		await doSearch()
	}
)

watch(selectedTags, (newTags) => {
	store.selectedTags = newTags.map(t => t.Id)
}, { deep: true })

const chipStyle = (t: any) => {
	const active = allSelectedStages.value.includes(t.Id);
	const base = {
		borderLeftColor: t.Color,
		backgroundColor: 'transparent'
	}
	if (active) {
		base.backgroundColor = hexToRgba(t.Color, 0.121);
	}

	return base;
}

const chipColoredStyle = (t: any) => {
	return {
		backgroundColor: t.Color
	}
}

function hexToRgba(hex: string, alpha: number) {
	const res = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!res) return hex;
	const r = parseInt(res[1], 16);
	const g = parseInt(res[2], 16);
	const b = parseInt(res[3], 16);
	return `rgba(${r},${g},${b},${alpha})`;
}

watch(filter, (newValue, oldValue) => {
	if (!newValue && oldValue) {
		doSearch()
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

watch(selectedCategory, () => {
	store.selectedStage = selectedCategory.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
			'projects-list': true,
			'projects-list--empty': props.isCollapsed,
		})
  }, [
    (!props.isCollapsed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(AppTooltip, { text: createProjectTitle.value }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "projects-list__filters-btn",
                    name: "plus",
                    width: "20px",
                    color: "#979797",
                    "hover-color": createProjectHoverColor.value,
                    cursor: createProjectCursor.value,
                    onClick: onCreateProject
                  }, null, 8, ["hover-color", "cursor"])
                ]),
                _: 1
              }, 8, ["text"]),
              (!isEntityPage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(AppInput, {
                        modelValue: filter.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
                        placeholder: _ctx.$t('search_label'),
                        "show-search-button": "",
                        onPressEnter: doSearch,
                        onSearch: doSearch
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(AppSelect, {
                        modelValue: selectedCategory.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCategory).value = $event)),
                        placeholder: _ctx.$t('select_category'),
                        items: optionsDisplay.value,
                        "min-dropdown-width": 272,
                        searchable: ""
                      }, null, 8, ["modelValue", "placeholder", "items"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(AppInput, {
                      modelValue: filter.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter).value = $event)),
                      placeholder: _ctx.$t('search_label'),
                      "show-search-button": "",
                      onPressEnter: doSearch,
                      onSearch: doSearch
                    }, null, 8, ["modelValue", "placeholder"])
                  ])),
              _createVNode(AppResizableDropdown, {
                ref_key: "$dropdownRef",
                ref: $dropdownRef,
                position: "right",
                "close-by-click-outside": true,
                "max-width": 640,
                "max-height": 436,
                "mobile-title": _ctx.$t('choose_tags'),
                name: "$dropdownRefClientsTags"
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppTooltip, {
                    text: _ctx.$t('ui_tag_filter')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        name: "hash",
                        width: "20px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer"
                      })
                    ]),
                    _: 1
                  }, 8, ["text"])
                ]),
                default: _withCtx(() => [
                  _createVNode(AppTagSelector, {
                    modelValue: selectedTags.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedTags).value = $event)),
                    "entity-type": _unref(TagEntityType).Project,
                    mode: "filter",
                    "allow-create": "",
                    "allow-select-group": "",
                    onClose: _cache[4] || (_cache[4] = ($event: any) => ($dropdownRef.value?.close()))
                  }, null, 8, ["modelValue", "entity-type"])
                ]),
                _: 1
              }, 8, ["mobile-title"]),
              (isEntityPage.value)
                ? (_openBlock(), _createBlock(AppResizableDropdown, {
                    key: 2,
                    ref_key: "$clientFilterDropdownRef",
                    ref: $clientFilterDropdownRef,
                    position: "right",
                    "close-by-click-outside": true,
                    "ignore-click-outside": "[data-client-filter-chip]",
                    "max-width": 640,
                    "max-height": 436,
                    "mobile-title": _ctx.$t('choose_clients'),
                    name: "$dropdownProjectClientFilter",
                    onClose: _cache[6] || (_cache[6] = ($event: any) => (focusFilterClient.value = null))
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppTooltip, {
                        text: _ctx.$t('clients_filter')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            name: "filter",
                            width: "20px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer"
                          })
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(ProjectClientFilterDropdown, {
                        "focus-client": focusFilterClient.value,
                        onClose: _cache[5] || (_cache[5] = ($event: any) => ($clientFilterDropdownRef.value?.close())),
                        onChange: doSearch
                      }, null, 8, ["focus-client"])
                    ]),
                    _: 1
                  }, 8, ["mobile-title"]))
                : _createCommentVNode("", true)
            ]),
            (isEntityPage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(AppSelect, {
                      modelValue: selectedCategory.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedCategory).value = $event)),
                      placeholder: _ctx.$t('select_category'),
                      items: optionsDisplay.value,
                      "min-dropdown-width": 272,
                      searchable: ""
                    }, null, 8, ["modelValue", "placeholder", "items"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stageItemsForSelectedStage.value, (t) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: t.Id
              }, [
                (t.Count || allSelectedStages.value.includes(t.Id))
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 0,
                      text: t.Name
                    }, {
                      activator: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "tag-chip",
                          style: _normalizeStyle(chipStyle(t)),
                          onClick: ($event: any) => (toggleStage(t.Id))
                        }, [
                          _createElementVNode("div", {
                            class: "tag-chip__colored",
                            style: _normalizeStyle(chipColoredStyle(t))
                          }, null, 4),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(t.Count), 1)
                        ], 12, _hoisted_10)
                      ]),
                      _: 2
                    }, 1032, ["text"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          (isEntityPage.value && (byBase.value || selectedClients.value.length))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (byBase.value)
                  ? (_openBlock(), _createBlock(ProjectSelectedClientItem, {
                      key: 0,
                      client: byBaseItem.value,
                      "role-editable": false,
                      removable: false,
                      onOpenFilter: _cache[8] || (_cache[8] = ($event: any) => (openClientFilterAt(byBaseItem.value)))
                    }, null, 8, ["client"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedClients.value, (c) => {
                  return (_openBlock(), _createBlock(ProjectSelectedClientItem, {
                    key: `${c.Id}-${c.UseUnion}`,
                    client: c,
                    onRemove: ($event: any) => (removeClient(c.Id)),
                    onChange: doSearch,
                    onOpenFilter: ($event: any) => (openClientFilterAt(c))
                  }, null, 8, ["client", "onRemove", "onOpenFilter"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (selectedTags.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTags.value, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag.Id,
                    class: "projects-list__selected-tags-item"
                  }, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(tag.Name), 1),
                    _createVNode(AppIcon, {
                      class: "projects-list__selected-tags-item-delete",
                      name: "close-bold",
                      size: "12px",
                      color: "#D2D2D2",
                      "hover-color": "#4D4D4D",
                      cursor: "pointer",
                      onClick: _withModifiers(($event: any) => (dropTag(tag)), ["stop"])
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "projects-list__filters-counter",
            style: _normalizeStyle({ margin: props.isCollapsed ? 'auto 0' : '8px 0' }),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('on-toggle'))),
            onMouseenter: _cache[10] || (_cache[10] = ($event: any) => (isCounterHovered.value = true)),
            onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (isCounterHovered.value = false))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t(hasAnyFilter.value ? 'projects_found' : 'projects_total')) + ":  ", 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(projectsCount.value), 1),
            _createVNode(AppTooltip, {
              class: "projects-list__filters-counter-tooltip",
              text: _ctx.$t(props.isSecondCollapsed ? 'ui_shrink' : 'ui_expand')
            }, {
              activator: _withCtx(() => [
                _createVNode(AppIcon, {
                  class: "projects-list__filters-counter-icon",
                  name: props.isSecondCollapsed ? 'small-screen' : 'full-screen',
                  size: "14px",
                  color: isCounterHovered.value ? '#438451' : '#979797',
                  "hover-color": "#438451",
                  cursor: "pointer"
                }, null, 8, ["name", "color"])
              ]),
              _: 1
            }, 8, ["text"]),
            (hasAnyFilter.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "projects-list__filters-counter-drop-filters",
                  onClick: _withModifiers(dropFilters, ["stop"])
                }, _toDisplayString(_ctx.$t('selector_reset')), 1))
              : _createCommentVNode("", true)
          ], 36),
          _createElementVNode("div", {
            class: "projects-list__body",
            ref_key: "$projectsList",
            ref: $projectsList,
            onScroll: onProjectsScroll
          }, [
            (projectsLoading.value)
              ? (_openBlock(), _createBlock(AppLoader, {
                  key: 0,
                  style: _normalizeStyle(loaderStyle.value)
                }, null, 8, ["style"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: project.Id
              }, [
                _createVNode(ProjectListItem, { project: project }, null, 8, ["project"]),
                (index + 1 < projects.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createVNode(AppScrollTopButton, {
              enabled: _unref(isScrollTopEnabled),
              onOnClick: _unref(scrollToTop)
            }, null, 8, ["enabled", "onOnClick"])
          ], 544)
        ], 64))
      : (_openBlock(), _createBlock(AppTooltip, {
          key: 1,
          class: "projects-list__empty-tooltip",
          text: _ctx.$t('ui_expand')
        }, {
          activator: _withCtx(() => [
            _createElementVNode("div", {
              class: "projects-list__empty",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (emit('on-toggle'))),
              onMouseenter: _cache[13] || (_cache[13] = ($event: any) => (isCounterHovered.value = true)),
              onMouseleave: _cache[14] || (_cache[14] = ($event: any) => (isCounterHovered.value = false))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t(hasAnyFilter.value ? 'projects_found' : 'projects_total')) + ":  ", 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(projectsCount.value), 1),
              _createVNode(AppIcon, {
                class: "projects-list__empty-icon",
                name: "full-screen",
                width: "14px",
                color: isCounterHovered.value ? '#438451' : '#979797',
                "hover-color": "#438451"
              }, null, 8, ["color"])
            ], 32)
          ]),
          _: 1
        }, 8, ["text"]))
  ], 2))
}
}

})